/**
 * The sign-in wall shown when Clerk is configured (see `lib/auth.ts`) and the browser has no
 * Clerk session. Signing in here only proves identity to Bosun — it does not, by itself, get
 * the browser a Frappe `sid` cookie. See `lib/auth.ts`'s header for the full boundary.
 */

import { SignIn } from '@clerk/clerk-react'

export function ClerkSignInScreen() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
      }}
    >
      <SignIn />
    </div>
  )
}
